import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "loading", "error", "label", "hint"]
  static values = { url: String }

  connect() {
    this.modal = this.element.closest(".modal")
    this.boundLoadDisplayName = this.loadDisplayName.bind(this)
    this.modal?.addEventListener("show.bs.modal", this.boundLoadDisplayName)
  }

  disconnect() {
    this.modal?.removeEventListener("show.bs.modal", this.boundLoadDisplayName)
  }

  loadDisplayName() {
    this.reset()

    fetch(this.urlValue, {
      credentials: "same-origin",
      headers: { Accept: "application/json" },
    })
      .then((response) => response.json())
      .then((data) => {
        this.hideLoading()

        if (data.display_name) {
          this.inputTarget.value = data.display_name
          this.showSuccess()
        } else {
          this.showError()
        }
      })
      .catch(() => {
        this.hideLoading()
        this.showError()
      })
  }

  reset() {
    this.inputTarget.value = ""
    this.inputTarget.classList.add("d-none")
    if (this.hasLoadingTarget) {
      this.loadingTarget.classList.remove("d-none")
    }
    if (this.hasErrorTarget) {
      this.errorTarget.classList.add("d-none")
    }
    if (this.hasLabelTarget) {
      this.labelTarget.classList.remove("d-none")
    }
    if (this.hasHintTarget) {
      this.hintTarget.classList.add("d-none")
    }
  }

  hideLoading() {
    if (this.hasLoadingTarget) {
      this.loadingTarget.classList.add("d-none")
    }
  }

  showSuccess() {
    this.inputTarget.classList.remove("d-none")
    if (this.hasHintTarget) {
      this.hintTarget.classList.remove("d-none")
    }
  }

  showError() {
    if (this.hasErrorTarget) {
      this.errorTarget.classList.remove("d-none")
    }
    if (this.hasLabelTarget) {
      this.labelTarget.classList.add("d-none")
    }
  }
}
